<template>
  <div>
    <open-banking-bankito-excel-filter v-if="$can('read', 'open-banking')" :action="exportToExcel" :query="query_filter_excel" :form_id="excel_filter_form_id"></open-banking-bankito-excel-filter>
    <div class="fh-datatable bg-white" v-if="status === 'success'">
      <table v-if="excelRequests.data.length > 0" class="table table-light-bordered">
        <thead>
        <tr style="font-size: 0.89rem;">
          <td style="text-align: center; width:70px">#</td>
          <td style="text-align: center">{{ $t('label.from_date') }}</td>
          <td style="text-align: center">{{ $t('label.to_date') }}</td>
          <td>{{ $t('label.status') }}</td>
          <td style="text-align: center">عملیات</td>
        </tr>
        </thead>
        <tbody>
        <tr v-bind:key="index" v-for="(req, index) in excelRequests.data">
          <td style="text-align: center">{{ req.id }}</td>
          <td style="text-align: center">{{ req.from_date }}</td>
          <td style="text-align: center">{{ req.to_date }}</td>
          <td style="text-align: center" class="text-center">
            <div class="text-white" :class="excelStatusVariant(req.status)">
              {{ excelStatusStr(req.status) }}
            </div>
          </td>
          <td class="text-center d-flex justify-content-center align-items-center">
            <a v-show="req.url" :href="req.url" type="button"
               style="background: none; border: none; color: #7878e4">
              <i class="fa fa-download"></i>
            </a>
            <button @click="handleReqDelete(req.id)"
                    style="background: none; border: none; color: #c90000">
              <i class="fa fa-trash"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <div v-if="excelRequests.data.length > 0" class="pager kt-datatable--paging-loaded">
        <div class="paginationR">
          <button class="btn-link" title="اولی" @click="changePage(1)">
            &laquo;&laquo;
          </button>
          <button class="btn-link" title="قبلی" @click="changePage(excelRequests.current_page - 1)">
            &laquo;
          </button>
          <span
              v-for="(page, index) in ((excelRequests.current_page) - 2, excelRequests.current_page + 2)"
              :key="index">
                                    <button
                                        v-if="(page <= excelRequests.last_page) && page > excelRequests.current_page - 3"
                                        @click="changePage(page)" :id="'page_' + page"
                                        :class="{ 'active': (excelRequests.current_page == index + 1) }">
                                        {{ page }}
                                    </button>
                                </span>
          <button class="btn-link" title="بعدی" @click="changePage(excelRequests.current_page + 1)">
            &raquo;
          </button>
          <button class="btn-link" title="آخری" @click="changePage(excelRequests.last_page)">
            &raquo;&raquo;
          </button>
        </div>
        <div class="pager-info">
          <select class="mr-3 ml-3 kt-datatable__pager-size" style="width: 60px;" title="اندازه صفحه"
                  @change="changePage(excelRequests.current_page)" id="perpage-value" v-model="per_page">
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select>
          <span class="kt-datatable__pager-detail">
                                    {{ 'نمایش ' + excelRequests.from + ' - ' + excelRequests.to + ' از ' +
          excelRequests.total }}
                                </span>
        </div>
      </div>
      <div v-else class="text-center p-5 my-3">
        درخواست خروجی اکسل برای شما وجود ندارد!
      </div>
    </div>
    <div class="loader" style="display:none"></div>
  </div>
</template>


<script>
import {mapGetters} from "vuex";
import OpenBankingBankitoExcelFilter from "./open-banking-bankito-excel-filter.vue";
import {openBankingService, transactionService} from '@/common/api.service'
import $ from "jquery";
import {i18n} from "@/plugins/i18n";
import {KTApp} from "@/plugins/core/app";

export default {
  components: {
    OpenBankingBankitoExcelFilter
  },
  data() {
    return {
      headerAction: {
        left: '10px',
        top: '10px',
        position: 'absolute'
      },
      query: {},
      query_filter_excel: {},
      excel_filter_form_id: 'excel',
    }
  },
  computed :{
    ...mapGetters('user', [
      'current_user'
    ]),
    ...mapGetters('openBankingRequests', [
      'status', 'excelRequests'
    ]),
  },
  methods :{
    handleReqDelete(hashid) {
      transactionService.deleteCoreExcelRequest(hashid)
          .then(response => {
            this.$store.dispatch('openBankingRequests/fetchCoreExcelTransfer', this.params).finally(() => {
              localStorage.setItem('excelRequests_per_page', this.excelRequests.per_page)
            })
            this.toastr.success(response.data.message);
          })
          .catch(({ response }) => {
            this.toastr.error(response.data.message);
          })
    },
    fillParams() {
      this.params = {
        page: this.page,
        perpage: this.per_page,
        type: 'open_banking_bankito',
      }
    },
    changePage(pagee) {
      this.page = pagee
      this.fillParams()
      this.$store.dispatch('openBankingRequests/fetchCoreExcelTransfer', this.params).finally(() => {
        localStorage.setItem('excelRequests_per_page', this.excelRequests.per_page)
      })
    },
    excelStatusVariant(status) {
      if (status == "CREATED")
        return "badge badge-secondary"

      if (status == "PROCESSING")
        return "badge badge-warning"

      if (status == "PROCESSED")
        return "badge badge-success"
    },
    excelStatusStr(status) {
      if (status == "CREATED")
        return i18n.t('transaction.excelStatus.created')

      if (status == "PROCESSING")
        return i18n.t('transaction.excelStatus.processing')

      if (status == "PROCESSED")
        return i18n.t('transaction.excelStatus.processed')
    },
    exportToExcel(e, query) {
      let btn = $(e.target);
      let form = $('#open-banking-bankito-filter-form-' + this.excel_filter_form_id)

      form.validate({
        rules: {
          from_date: {
            required: true,
          },
          to_date: {
            required: true,
          },
        },
      });

      if (!form.valid()) {
        return;
      }

      KTApp.progress(btn)

      this.query_filter_excel = query

      openBankingService.createCoreExcelTransfer({
        ...this.query_filter_excel
      }).then(async (response) => {
        await this.$store.dispatch('openBankingRequests/fetchCoreExcelTransfer', this.params)
        this.toastr.success(response.data.message)
      }).catch(({ response }) => {
        form.validate().showErrors(response.data.data)
      }).finally(() => {
        KTApp.unprogress(btn)
      });
    },
    changeBoard(board) {
      this.board = board;
    },
  },
  mounted() {
    this.fillParams();
    this.$store.dispatch('openBankingRequests/fetchCoreExcelTransfer', this.params).finally(() => {
      localStorage.setItem('excelRequests_per_page', this.excelRequests.per_page)
    })
  }
}
</script>